module.exports = __webpack_public_path__ + "paste.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/paste.svg?color1=%23333333&color2=
// module id = 2207
// module chunks = 67